import { PageResponse } from '..';

export class Label {
    id: string;
    name: string;
    severity: string;
    score?: number;
    type: LabelType;
}

export enum LabelType {
    PREDEFINED = 'PREDEFINED',
    CUSTOMER = 'CUSTOMER'
}

export enum LabelSeverity {
    INFO = 'INFO',
    SUCCESS = 'SUCCESS',
    WARN = 'WARN',
    ERROR = 'ERROR'
}

export class AddLabelRequest {
    constructor(public labelId: string, public projectId: string) {
    }
}

export class CreateUpdateLabelRequest {
    constructor(public id: string, public name: string, public color: string, public score: number, public type: LabelType) {
    }
}


export class LabelResponse extends PageResponse {
    content: Label[];
}
